import { BaseHeader } from "@morph-mapper/ui";
import styled from "@emotion/styled";

export const StyledHeader = styled(BaseHeader)(({ theme }) => ({
  backgroundColor: theme.colors.gray[1],
}));
